import { useEffect } from "react";
import { useQueryClient } from "react-query";
import { useSelector } from "react-redux";

import { ApplicationHubService } from "helpers";
import {
	getApplicationListTab,
	getPage,
	getSort,
	getFilters,
} from "store/applicationList/applicationList.reducer";

export const useSignalR = () => {
	const queryClient = useQueryClient();
	// Needed for query key
	const tab = useSelector(getApplicationListTab);
	const page = useSelector(getPage);
	const sort = useSelector(getSort);
	const filters = useSelector(getFilters);

	useEffect(() => {
		ApplicationHubService.onReceiveApplicationStatus(
			({ id, applicationStatus: { name }, canBeEdited }) => {
				queryClient.setQueryData<any>(
					["applicationList", { tab, page, sort, filters }],
					(oldData: any) => {
						return {
							...oldData,
							applications: oldData?.items?.map(app =>
								app.id === id
									? { ...app, status: name, canBeEdited }
									: app,
							),
						};
					},
				);
			},
		);
	}, [queryClient, tab, page, sort, filters]);
};
